import React, { Fragment } from 'react'

import { Link } from 'react-router-dom'
import styled from 'styled-components'

import {
    SimpleBlock,
    SimpleCarousel,
} from '../'
import { useWindowSize } from '../../_helpers'
import {
    Container,
    Grid,
    UpperHeader,
    devices,
    PrimaryButton,
    colors,
} from '../Common'


export const PageBlock = ({ pageBlock, siblings, border, page_menu }) => {
    const { format, title } = pageBlock
    const { width } = useWindowSize()
    const mobile = width < 480

    if (mobile && pageBlock.format === 'LEFT-IMAGE') {
        return (
            <MobileImageBlock bg={pageBlock.image}>
                <MobileText>
                    <h2>{title}</h2>
                    <div dangerouslySetInnerHTML={{ __html: pageBlock.content2 }} />
                    <PrimaryButton
                        as={pageBlock.linked_page2 ? Link : 'a'}
                        to={pageBlock.linked_page2 ? pageBlock.linked_page2 : ''}
                        href={pageBlock.external_url2}
                    >
                        {pageBlock.link_text2}
                    </PrimaryButton>
                </MobileText>
            </MobileImageBlock>
        )
    }

    return (
        <DynamicWidthBlock
            paddingtop={border ? 50 : 0}
            paddingbottom={['LIST-WITHOUT-PADDING', 'NEWS'].includes(pageBlock.format) ? 0 : 50}
            border={border}
            page_menu={page_menu}
            isFeaturedPlant={format === 'FEATURED-PLANT'}
            id={pageBlock.hash}
        >
            <BlockContainer
                page_menu={page_menu}
            >
                {pageBlock.hash_url ? <div id={pageBlock.hash_url.toLowerCase().replace(/ /g, '_')} /> : ''}
                {format === 'CAROUSEL' ? <SimpleCarousel slides={pageBlock.carousel} content={pageBlock.content} smallTitle={pageBlock.small_title} /> : ''}
                {format === '1-COLUMN' ? (
                    <SimpleBlock
                        pageBlock={pageBlock}
                        siblings={siblings}
                        columns={1}
                    />
                ) : ''}
                {format === '2-COLUMN-LINK' || format === 'LEFT-IMAGE' || format === 'RIGHT-IMAGE' ? (
                    <Grid columns={2} totalmargin={15}>
                        {['', '2'].map(id => (
                            <SimpleBlock
                                key={`#${id}`}
                                id={id}
                                pageBlock={pageBlock}
                                textPadding={'20%'}
                                columns={2}
                            />
                        ))}
                    </Grid>
                ) : ''}
                {format === '3-COLUMN' ? (
                    <Fragment>
                        {pageBlock.show_title && !pageBlock.title2 ? <UpperHeader>{pageBlock.title}</UpperHeader> : ''}
                        <Grid columns={3} totalmargin={15} margintop={!pageBlock.title2 ? 0 : 0}>
                            {['', '2', '3'].map(id => (
                                <SimpleBlock
                                    key={`#${id}`}
                                    id={id}
                                    pageBlock={pageBlock}
                                    textPadding={!pageBlock.title2 ? '10%' : 0}
                                    columns={3}
                                    hideTitle={true}
                                    square={true}
                                />
                            ))}
                        </Grid>
                    </Fragment>
                ) : ''}
            </BlockContainer>
        </DynamicWidthBlock>
    )
}

const DynamicWidthBlock = styled.div`
    ${({paddingtop}) => paddingtop && `
        padding-top: ${paddingtop}px;
    `}

    ${({paddingbottom}) => paddingbottom && `
        padding-bottom: ${paddingbottom}px;
    `}

    ${({border}) => border && `
        &:before {
            content: "";
            display: block;
            position: relative;
            top: -50px;
            border-top: 1px solid ${colors.darkGreen};
        }
    `}

    ${({border, page_menu}) => border && !page_menu && `
        &:before {
            width: calc(100% - 105px - 105px);
            max-width: 1100px;
            margin-left: auto;
            margin-right: auto;

            @media ${devices.mobile} {
                width: calc(100% - 20px - 20px);
            }
        }
    `}

    ${({isFeaturedPlant}) => isFeaturedPlant && `
        background-color: ${colors.darkGreen};
        color: ${colors.white};

        @media ${devices.mobile} {}
    `}
`

const BlockContainer = styled(Container)`
    ${({page_menu}) => page_menu && `
        width: 100%;
        max-width: 100%;
        margin-left: 0;
        margin-right: 0;
        padding-left: 0;
        padding-right: 0;
    `}
`

const MobileImageBlock = styled.div`
    background: url(${({ bg }) => bg}) center/cover no-repeat;
    height: 100vh;
`

const MobileText = styled.div`
    padding: 30px 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end;
    color: ${colors.white};
    height: 100%;
    background-image: linear-gradient(to bottom, rgba(255,0,0,0), rgba(50,86,68,1));

    h2 {
        margin-bottom: 20px;
    }

    ${PrimaryButton} {
        margin-left: auto;
        margin-right: auto;
        margin-top: 20px;
    }
`
